export default __webpack_public_path__ + "static/media/search.8b46bbd8.svg";